export const tableName = {
  role: "role",
  permission: "permission",
  email_configuration: "email_configuration",
  sms_configuration: "sms_configuration",
  letter_head: "LetterHead",
  print_format: "PrintFormat",
  workflow_state_master: "Workflow_state_master",
  workflow_action: "Workflow_Action",
  workflow: "Workflow",
  import_management: "data_import",
  translations: "DynamicTranslation",
  schema: "Schema",
  tenant_user: "TenantUser",
  socialConfigurationTable: "SocialConfiguration",
};
